<!--
  - @copyright Internet Business Partner, all rights reserved (c) 2020
  - @author    Marek Lisiecki <m.lisiecki@ibp.net.pl>
  - @license   Commercial
  -->

<template>
    <div>
        <Slider/>
        <HomeFourBox/>
        <SearchBox/>
        <div id="special" data-url="/home/special">
            <SpecialOfferBox/>
        </div>
        <div id="about" data-url="/home/about">
            <AboutUsBox/>
        </div>
        <GoogleMaps :lat="50.841850" :lng="19.120090"/>
        <div id="contact" data-url="/home/contact"></div>
    </div>
</template>

<script>
import SearchBox from "@/components/SearchBox";
import SpecialOfferBox from "@/components/SpecialOfferBox";
import AboutUsBox from "@/components/AboutUsBox";
import HomeFourBox from "@/components/HomeFourBox";
import GoogleMaps from "@/components/GoogleMaps";
import Slider from "@/components/Slider";

const scrollToElement = (params) => {
    setTimeout(() => {
        if (Object.values(params).length) {
            if (params.block) {
                let el = document.querySelector('#' + params.block)
                let position = el.getBoundingClientRect()

                window.scrollTo({
                    top: position.top + window.scrollY - 70,
                    behavior: 'smooth',
                    block: 'nearest'
                })
            }
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }, 1000)
}



export default {
    name: "home",
    props: ["block"],
    components: { Slider, GoogleMaps, HomeFourBox, AboutUsBox, SpecialOfferBox, SearchBox },
    data () {
        return {
            scrollInterval: null
        }
    },
    watch: {
        $route (to, from) {
            scrollToElement(to.params)
        }
    },
    mounted () {
        this.observer.observe(document.querySelector('#about'));
        this.observer.observe(document.querySelector('#contact'));
        this.observer.observe(document.querySelector('#special'));
        this.observer.observe(document.querySelector('#header'));
    },
    created () {
        this.observer = new IntersectionObserver(
            this.observerFunction
        );

        let params = this.$route.params

        if (Object.values(params).length) {
            scrollToElement(params)
        }
    },
    methods: {
        observerFunction (entries) {
            entries.forEach(({ target, isIntersecting }) => {
                if (! isIntersecting) {
                    return;
                }
            });
        }
    },
    beforeUnmount () {
        this.observer.disconnect();
    }
}
</script>

<style scoped lang="scss">

</style>